/**
 * Shared DOM attribute names used as cross-component contracts.
 *
 * These attributes are load-bearing for portaled overlays that must
 * coexist (e.g. the cookie consent banner and the Auto Tune Settings
 * drawer). Components that expose or rely on the contract reference
 * the constant here so a search reveals the link.
 */

/**
 * Tags the cookie consent banner root element so portaled modals
 * (e.g. the Auto Tune drawer's `Sheet`) can detect outside clicks
 * that originated inside the banner and skip their close handlers.
 *
 * Set on: `apps/web/src/components/cookieConsentBanner/CookieConsentBanner.tsx`
 * Read by: `apps/web/src/pages/jobs/auto-tune/drawer/AutoTuneSettingsDrawer.tsx`
 */
export const COOKIE_CONSENT_ATTR = "data-cookie-consent";
